// extracted by mini-css-extract-plugin
export var navbar = "header-module--navbar--kwNbS";
export var brand = "header-module--brand--nUBf7";
export var brandName = "header-module--brand-name--7+RiO";
export var menu = "header-module--menu--Tzp5Z";
export var toggler = "header-module--toggler--TUGCa";
export var navCollapse = "header-module--nav-collapse--+z2GT";